module.exports = __webpack_public_path__ + "img/f_fabu.266d695e.png";